<template>
  <div class="basisModel">
    <!-- 这个是顶部导航 -->
    <headers :title="documentTitle"></headers>
    <van-search
      shape="round"
      v-model="value"
      show-action
      placeholder="请输入搜索关键词"
    >
      <template #action>
        <van-button color="#F3645E" size="small" round @click="onClickButton">
          搜索
        </van-button>
      </template>
    </van-search>

    <div class="statement" v-if="systemFont">
      <van-notice-bar
        left-icon="volume-o"
        color="#f14a43"
        background="#fff5f5"
        :text="systemFont"
      />
    </div>
    <div class="classfiy">
      <van-tabs v-model:active="active" @change="changeclass">
        <van-tab
          v-for="(item, index) in classfiy"
          :key="index"
          :title="item.name"
        />
      </van-tabs>

      <div class="buttons" @click="toclassfiy">
        <!-- <van-icon name="wap-nav" /> -->
        <div class="btn">
          <span>更多</span>
          <van-icon class="icon" name="play" />
        </div>
      </div>
    </div>
    <van-list
      :immediate-check="false"
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      ref="listRef"
    >
      <van-cell
        v-for="item in list"
        :key="item.id"
        @click="toothorpage(item.link)"
      >
        <ul class="lists">
          <li>
            <div class="left">
              <div style="min-height: 50px">
                <h5 class="o2">{{ item.title }}</h5>
              </div>
              <p>
                <span>{{ item.mp_name }}</span
                >{{ item.pub_time }}
              </p>
            </div>
            <div class="right">
              <img
                :src="
                  'http://yxy.medsky.cn/api/mpsucker/img?path=' + item.cover
                "
                alt=""
              />
              <div class="tuijian" v-if="item.is_rec === 1">
                <img src="../../assets/image/tuijian.jpg" alt="" />
              </div>
            </div>
          </li>
        </ul>
      </van-cell>
    </van-list>
  </div>
</template>
<script setup>
import { indexlist, getclassfiy, sharewx, systemInfo } from "../../api/index";
import headers from "../../components/header.vue";
import {
  ref,
  onMounted,
  nextTick,
  getCurrentInstance,
  watch,
  onBeforeMount,
} from "vue";
import { useRouter, useRoute, onBeforeRouteUpdate } from "vue-router";
import wx from "weixin-js-sdk";
import useDataInfo from "../../store/index";
const dataInfo = useDataInfo();
const router = useRouter();
const route = useRoute();
// const store = useStore()
// 搜索框
const value = ref("");
const page = ref(1);
const list = ref([]);
const loading = ref(false);
const finished = ref(false);
let instance = "";
const ShareTitle = ref();

const systemFont = ref();

// 点击搜索按钮请求接口
const onClickButton = () => {
  page.value = 1;
  list.value = [];
  onLoad();
};
const id = ref(0);
// 路由
const active = ref(0);
if (route.query.id) {
  active.value = Number(route.query.id);
}

// 获取分类的接口
const classfiy = ref([]);
const documentTitle = ref("");
async function getclassfiyd() {
  const res = await getclassfiy(route.query.pid ? route.query.pid : 0);
  if (res.code === 1) {
    document.title = res.data.title;
    res.data.datalist.unshift({ id: 0, name: "全部" });
    documentTitle.value = res.data.title;
    ShareTitle.value = res.data.title;
    classfiy.value = res.data.datalist;
    id.value = classfiy.value[active.value].id;
    onLoad();
  }
}

// 下拉刷新
const onLoad = async () => {
  const res = await indexlist(
    value.value,
    page.value,
    id.value,
    route.query.pid
  );
  if (res.code === 1) {
    list.value.push(...res.data.data);
    loading.value = false;
    if (list.value.length >= res.data.total) {
      finished.value = true;
    } else {
      page.value++;
      finished.value = false;
    }
  }
};

// 跳转到分类页面
function toclassfiy() {
  sessionStorage.setItem("WXTabsIndex", active.value);
  router.push(`/classfiy?pid=${route.query.pid}&type=basis`);
}
// 筛选分类 切换
var url =
  "http://act.medsky.cn/#/?pid=" + route.query.pid + "&id=" + active.value;
/**
 * name:索引
 * title:标题
 * @param {*} param0
 */
const changeclass = (name, title) => {
  url =
    "http://act.medsky.cn/#/?pid=" + route.query.pid + "&id=" + active.value;
  if (title === "全部") {
    ShareTitle.value = documentTitle.value;
  } else {
    ShareTitle.value = `${title} @${documentTitle.value}`;
  }
  share();
  id.value = classfiy.value[name].id;
  sessionStorage.setItem("WXTabsID", id.value);
  page.value = 1;
  list.value = [];
  onLoad();
};
// 微信sdk的分享功能、
// 获取全路径
async function share() {
  const res = await sharewx(
    ["updateAppMessageShareData", "updateTimelineShareData"],
    url
  );
  console.log(res, "res");
  if (res.code === 1) {
    wx.config({
      debug: false,
      appId: res.data.appid, // 和获取Ticke的必须一样------必填，公众号的唯一标识
      timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.data.noncestr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名，见附录1
      // 需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
      jsApiList: res.data.jsApiList,
    });
    // classfiy.value[active.value].name
    // 分享到朋友圈
    wx.ready(function () {
      wx.updateAppMessageShareData({
        title: ShareTitle.value, // 分享标题
        desc: "高质量医学信息和专业知识！", // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: "http://act.medsky.cn/base.png", // 分享图标
        success: function () {
          // 设置成功
          // alert(ShareTitle.value, "设置成功");
        },
      });
      wx.updateTimelineShareData({
        title: ShareTitle.value, // 分享标题·
        desc: "高质量医学信息和专业知识！", // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: "http://act.medsky.cn/base_p.png", // 分享图标
        success: function () {
          // 设置成功
          // alert(ShareTitle.value, "设置成功");
        },
      });
    });
    wx.error(function (res) {
      console.log(res, "错误信息");
    });
  }
}
//***切换分类  或自定义操作时候 清空缓存***
onMounted(() => {
  share();
  huanchun();
  instance = getCurrentInstance();
  systemInfoAsync();
});
onBeforeMount(() => {
  getclassfiyd();
});
// 跳转到其他小程序页面
const toothorpage = (url) => {
  //先缓存数据
  //list 需要判断是否从缓存取， 渲染完成后 定位到WXobjTop ，注意清缓存
  if (page.value >= 1) {
    sessionStorage.setItem("WXPage", page.value);
    sessionStorage.setItem("WXValue", value.value);
    sessionStorage.setItem("WXlist", JSON.stringify(list.value));
  }
  window.open(url);
};
window.addEventListener("scroll", () => {
  sessionStorage.setItem("WXobjTop", window.scrollY);
});
//判断什么时候取出缓存
const huanchun = () => {
  if (
    sessionStorage.getItem("WXPage") >= 1 &&
    JSON.parse(sessionStorage.getItem("WXlist"))
  ) {
    let aaa = Number(sessionStorage.getItem("WXobjTop"));
    id.value = sessionStorage.getItem("WXTabsID");
    value.value = sessionStorage.getItem("WXValue");
    page.value = sessionStorage.getItem("WXPage");
    if (id.value == 0) active.value = 0;
    if (id.value == 75) active.value = 1;
    if (id.value == 61) active.value = 2;
    if (id.value == 62) active.value = 3;
    if (id.value == 63) active.value = 4;
    if (id.value == 73) active.value = 5;
    if (id.value == 74) active.value = 6;
    if (id.value == 79) active.value = 7;
    if (id.value == 87) active.value = 8;
    list.value = JSON.parse(sessionStorage.getItem("WXlist"));
    nextTick(() => {
      window.scrollTo(0, aaa);
    });
    sessionStorage.removeItem("WXValue");
    sessionStorage.removeItem("WXPage");
    sessionStorage.removeItem("WXlist");
    sessionStorage.removeItem("WXobjTop");
  } else {
    let id = sessionStorage.getItem("WXTabsID");
    onLoad();
  }
};
const systemInfoAsync = async () => {
  try {
    let res = await systemInfo();
    if (res.code == 1) {
      if (
        route.query.pid == 60 ||
        route.query.pid == 239 ||
        route.query.pid == 231 ||
        route.query.pid == 92 ||
        route.query.pid == 80
      ) {
        systemFont.value = res.data.head_copyright.data;
        console.log(systemFont.value, "systemFont.value");
      } else {
        systemFont.value = "";
      }
    }
  } catch (error) {
    console.log(error);
  }
};
//监听路由器切换
watch(
  () => router.currentRoute.value.path,
  (newValue, oldValue) => {
    if (oldValue === "/classfiy") {
      if (newValue === "/") {
        active.value = Number(sessionStorage.getItem("WXTabsIndex"));
        id.value = classfiy.value[active.value].id;
        list.value = [];
        value.value = "";
        page.value = 1;
        onLoad();
      }
    }
  },
  { immediate: true }
);
</script>
<style lang="less" scoped>
.van-button {
  padding: 0 20px;
}
/deep/.van-search__action {
  display: flex;
  align-items: center;
}
.Weixin_a {
  padding: 2px;
}
.statement {
  background: #fff5f5;
  font-size: 14px;
  color: #f14a43;
}
.classfiy {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  .van-tabs {
    flex: 1;
    // width: 300px;
    width: 78%;
    margin-right: 10px;
    /deep/ .van-tab--active {
      color: #f3645e;
      font-weight: bold;
      z-index: 10;
    }
  }
  .buttons {
    // width: 43px;
    // flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      padding: 8px 10px;
      height: 31px;
      box-sizing: border-box;
      background: #fff1f1;
      border-radius: 10px;
      margin-right: 15px;
      color: #e35a57;
      .icon {
        transform: rotate(90deg);
      }
    }

    // height: 43px;
    // box-shadow: -3px 0px 3px rgba(0, 0, 0, 0.16);
    // //font-size: 30px;
    // color: #666;
  }
}
.lists {
  li {
    display: flex;
    .left {
      flex: 1;
      h5 {
        font-size: 15px;
        color: #050505;
      }
      p {
        font-size: 11px;
        color: #bdbdbd;
        span {
          margin-right: 10px;
          color: #5f6e94;
        }
      }
    }
    .right {
      margin-left: 35px;
      width: 70px;
      height: 70px;
      overflow: hidden;
      position: relative;
      border-radius: 8px;
      img {
        width: 100%;
      }
      .tuijian {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 1;
        width: 34px;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
